import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import Eventaddpopup from './Eventaddpopup';
import Slider from "react-slick";
import {
  isMobile
} from "react-device-detect";

export default class Eventpopup extends Component {
  constructor(props)
  {
      super(props);
      this.state = {
          open: false,
          popups: null
      };
      this.customStyle = {
        maxWidth : '300px'
      };
      this.customStyle2 = {
        maxWidth : '600px'
      };
  }
  Open(_popup)
  {
    this.setState({
      popups: _popup,
      open: true
    });
  }
  Close(idx)
  {
      if( idx )
      {
        window.setCookie("popup"+idx, 1, 2);
      }
      this.setState({
          open: false
      });
  }
  Go(popup)
  {
    //this._eventAddpopup.Open(this.state.popup.title);
    this.props.onJoinChanged(popup.title);
  }

  /*
  <img className="img-responsive2" src={'https://api.tfamily.co.kr' + self.state.popup.img} />
  {(self.state.popup.type == 'S') ?
  <div className="text-center pt10 pb10">
    <a href="#applyGo" onClick={()=>{self.Go()}} className="btn btn-sm btn-default">사전예약참가</a>
  </div>
   : ''}
  */

  render()
  {
    let settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    };
      const self = this;
      return (
          (self.state.popups) ?
          <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
            <div className="modal-dialog  mb0"  style={(isMobile) ? this.customStyle : null} >
              <div className="text-center pt10 pb10">

                <Slider {...settings}>
                  {
                    self.state.popups.map(popup=>{
                      return (
                        <div key={popup.idx}>
                          <img  style={(!isMobile) ? this.customStyle2 : null} className={ (isMobile) ? 'img-responsive2' : 'img-responsive2 maxwidth600' } src={'https://api.tfamily.co.kr' + popup.img} />
                          {(popup.type == 'S') ?
                          <div className="text-center pt10 pb10">
                            <a href="#applyGo" onClick={()=>{self.Go(popup)}} className="btn btn-sm btn-default">사전예약참가</a>
                          </div>
                           : ''}
                        </div>
                      )
                    })
                  }
                </Slider>


                 <div className="text-right">
                  <small><a href="#closeAppl" onClick={()=>{self.Close(self.state.popups[0].idx)}}>오늘 하루동안 팝업창 닫기</a></small>
                 </div>
              </div>
            </div>
          </Modal> : null
        );
  }

}
